// Legacy 301: /termos-de-uso → /terminos-y-condiciones
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/termos-de-uso")({
  beforeLoad: () => {
    throw redirect({ to: "/terminos-y-condiciones", statusCode: 301 } as never);
  },
  component: () => null,
});
